
import SignalSections from './signal-sections.vue'
import Rest from 'utils/rest'
import CompanyTile from '../company-tile.vue'
import $pulse from 'stores/pulse'
import $contacts2 from 'stores/contacts2'
import ContactTile from '../contact-tile.vue'
import EditCompany from '../tracker/edit-company.vue'
import EditPerson from '../tracker/edit-person.vue'
import EditTopic from '../tracker/edit-topic.vue'
import {Cancelled} from 'utils/errors'
import TopicTile from '../topic-tile.vue'

export default {
  components: {CompanyTile, ContactTile, SignalSections, EditCompany, EditPerson, EditTopic, TopicTile},
  props: {
    signalId: {type: String, required: true},
    predefTab: {type: String, default: undefined},
  },
  emits: ['close'],
  data() {
    return {
      rest: new Rest(),
      active_tab: undefined,
      item: undefined,
      contact: undefined,
      company: undefined,
    }
  },
  computed: {
    loading(){
      return !this.item
    },
    persona_type(){
      return this.item.entity_type === 'persona' && this.item.parent_entity_name
    },
    company_type(){
      return this.item.entity_type === 'company'
    },
    topic_type(){
      return this.item.entity_type === 'topic'
    },
    anchors(){
      const anchors = this.item.sections?.filter(s => !!s.anchor).map(a => a.anchor)
      if (this.has_tracker) {
        anchors.push({value: 'tracker', title: 'Tracker', icon: 'settings-01'})
      }
      return anchors
    },
    tracker(){
      return this.active_tab === 'tracker'
    },
    has_tracker() {
      return this.item?.user_entity_id
    }
  },  
  created() {
    this.$listen('save', (data) => {
      this.item.type = data.tracker_type
      this.$dispatch('save')
    })

    this.$listen('track-person', ev => this.$dispatch('track-person', {...ev, from: {tab: this.active_tab}}))
    this.$listen('edit-person', ev => this.$dispatch('edit-person', {...ev, from: {tab: this.active_tab}}))
  },
  mounted(){
    this.$debounce_500(this.init)
  },
  beforeUnmount() {
    this.rest.abortAll()
    $contacts2.abortAll()
  },
  methods: {
    async init(){
      try {
        const item = await $pulse.loadSignal(this.signalId, this.rest)
        if (item.user_entity_id && item.entity_type === 'persona') {
          this.contact = await $contacts2.loadContact(item.user_entity_id)
        }

        if (item.entity_id && item.entity_type === 'topic') {
        //
        }

        this.item = item
        this.active_tab = this.predefTab || this.anchors[0]
      } 
      catch (e) {
        if (e instanceof Cancelled) return
        console.warn('Failed to load signal.\n', e)
        this.$dispatch('cancel')
        return
      }
    },
    async onTabClick(tab){
      if (this.tracker || tab.paneName === 'tracker') return
      this.$refs.sections.scrollTop(tab.paneName)
    },
  }
}
